<template>
  <v-chip small label :color="chipColor" :text-color="textColor" class="ma-0">
    {{ label || fallbackLabel }}
  </v-chip>
</template>

<script>
export default {
  name: 'UserActionStatusChip',
  props: {
    status: {
      type: String,
      default: 'in_progress',
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    chipColor() {
      const colors = {
        completed: 'green darken-1',
        done: 'green darken-1',
        in_progress: 'blue darken-1',
        pending_by_date: 'amber lighten-2',
        blocked: 'red darken-1',
        not_applicable: 'grey lighten-1',
        paused: 'blue-grey lighten-1',
      };

      return colors[this.status] || 'grey lighten-1';
    },
    textColor() {
      return this.status === 'pending_by_date' ? 'grey darken-4' : 'white';
    },
    fallbackLabel() {
      const labels = {
        completed: 'Completado',
        done: 'Realizado',
        in_progress: 'En curso',
        pending_by_date: 'Pendiente por fecha',
        blocked: 'Bloqueado',
        not_applicable: 'No aplica',
        paused: 'Pausada',
      };

      return labels[this.status] || this.status;
    },
  },
};
</script>
